import React, { useState } from 'react';
import { Tabs } from 'antd';
import { DollarOutlined, LineChartOutlined, FundOutlined, CreditCardOutlined, BarChartOutlined } from '@ant-design/icons';
import PageHeader from '../../../components/shared/PageHeader';

// Import components
import RevenueOverview from './components/RevenueOverview';
import RevenueCharts from './components/RevenueCharts';
import ForecastingChart from './components/ForecastingChart';
import PaymentAnalysis from './components/PaymentAnalysis';

const RevenueDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('overview');

  const tabItems = [
    {
      key: 'overview',
      label: (
        <span>
          <DollarOutlined />
          Revenue Overview
        </span>
      ),
      children: <RevenueOverview />,
    },
    {
      key: 'charts',
      label: (
        <span>
          <BarChartOutlined />
          Revenue Charts
        </span>
      ),
      children: <RevenueCharts />,
    },
    {
      key: 'forecasting',
      label: (
        <span>
          <LineChartOutlined />
          Forecasting
        </span>
      ),
      children: <ForecastingChart />,
    },
    {
      key: 'payments',
      label: (
        <span>
          <CreditCardOutlined />
          Payment Analysis
        </span>
      ),
      children: <PaymentAnalysis />,
    },
  ];

  return (
    <div>
      <PageHeader
        icon={<FundOutlined />}
        title="Revenue Dashboard"
        subtitle="Comprehensive financial performance tracking, revenue analysis, and forecasting insights"
      />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        items={tabItems}
      />
    </div>
  );
};

export default RevenueDashboard; 